import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import { App } from "./App";
import * as serviceWorker from "./serviceWorker";
import * as stores from "./stores";
import { Provider } from "mobx-react";
import { HashRouter } from "react-router-dom";
import MUITheme from "./theme";
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme(MUITheme);
const root = createRoot(document.getElementById("app"))

root.render(
  <ThemeProvider theme={theme}>
    <Provider {...stores}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </ThemeProvider>
)

serviceWorker.unregister();
